import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article10() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article11');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article9');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article10-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article10-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article10-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <h1 className="fs-xl f-lora mb-3">Scotland, One <br/>Step at a Time</h1>
            <h6 className="f-lora-i lh-base mb-4 mb-sm-5" variants={textAnimate}>Walking has shaped Scotland in more ways than you’d think, but what does it mean to us now?</h6>

            <p className="font-italic mb-0">words // Laura Anne Brown - photography // Laura Anne Brown, Sam Rogers & Simon Hird</p>
            <hr className="mb-4 mb-sm-5 "></hr>
            <img className="img-fluid mb-4"
              src={require("../../Images/article10-right-img1.jpg")}
            />
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>Why do we walk? It’s a question I often ask myself when I’m outdoors in Scotland. The answer threads back to the beginning of human life on this land. </p>
                <p className="" variants={textAnimate}>From 12,000 BC – when people first lived in Scotland – we’ve walked distances, our footsteps a patchwork with the history, culture and stories of the nation. We have walked cross-country to worship saintly relics. We have walked north to south, trading cattle and making money. We have walked to pray, work, shop, talk, love and say goodbye. </p>
                <p className="" variants={textAnimate}>It’s only in the last half-century or so, as car ownership became widespread, that we </p>
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>stopped walking in the same way. Walking long distances became something we did for leisure, at weekends, a challenge outside of the day job </p>
                <p className="" variants={textAnimate}>As I write, Scotland has 29 waymarked paths — our Great Trails — but there are many more, sometimes pathless, followed for desire or discovery and often in the footsteps of our ancestors. </p>
                <p className="" variants={textAnimate}>What does it mean to walk long distances in an age of screens, speed and sea change? What, so many centuries later, are we looking for? </p>
              </div>
            </div>
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>On a misty morning, I stand opposite the ruins of St Mungo’s Chapel. If you didn’t know it was here — a few crumbling walls on the road out of Culross — you’d walk right past it. It’s exactly this sort of overlooked history that the Fife Pilgrim Way aims to illuminate. </p>
                <p className="" variants={textAnimate}>This 64 mile (104 km) long-distance route, established in 2019, follows medieval pilgrim trails from Culross and North Queensferry across the county to St Andrews. Saintly relics were held in the town in an astounding abbey rivalling Rome, making St Andrews one of the most popular pilgrimage locations in Europe from the 10th to the late 15th century. </p>
                <p className="" variants={textAnimate}>What does it take to look after these paths now? I ask Tom Quayle, Access and Recreation Manager for Fife Coast and Countryside Trust, which also looks after the Fife Coastal Path. “Our wardens are the eyes and ears,” Tom tells me. “They walk these paths and pass on any issues to the maintenance team, who do the heavy lifting: resurfacing paths that’ve been worn away, clearing away windfall trees, putting in new steps and vegetation control in the summer.” </p>
                <p className="" variants={textAnimate}>It’s a big undertaking for a small team, so they work with the local council and landowners to ensure the paths remain accessible. But there are challenges. Remoteness (even in a populated area like Fife), distance and weather are the top three, Tom says, “but with climate change we’re getting more extreme weather events — heavier downpours, stronger winds, higher tides.” </p>
                <p className="" variants={textAnimate}>Even with the paths’ popularity, and laws in place to protect them, our landscapes continue to change rapidly. So how do we roam responsibly? The Fife Pilgrim Way, Tom says, is about “getting people out and about to the lesser-visited part of Fife, </p>
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>to discover the natural and built heritage they might not typically visit”. To choose the ‘hidden gems’ over the usual postcard places, and appreciate Scotland’s rich history while we’re at it. </p>
                <p className="" variants={textAnimate}>The air is thick with heat and the scent of midsummer. I’m standing in the heart of the Ochil Hills, searching for drovers’ roads.</p>
                <p className="" variants={textAnimate}>Dusty books, browser tabs, and a map have brought me here: Glen Eagles. The name is more often associated with the luxury hotel nearby, so I’m expecting this valley track to be harder to find. Yet it’s obvious, marked by an ornate gate to the right of the reservoir road. Ferns border one side, a stone wall the other. The track — gravel, grass, boulder — runs parallel to the modern road. Save the sound of a lonely car passing by, I could imagine myself, in these constant hills, in any time at all. </p>
                <p className="" variants={textAnimate}>It takes a kind of time travel to imagine Scotland’s droving tradition which, as historian A.R.B Haldane says in his book on the subject, “can be traced back as far as historical records exist”. Droving is the movement of cattle, and over the centuries this transformed from the simpler relocation of seasonal grazing sites to largescale commercial endeavours, particularly after the 1707 Acts of Union, which unfurled trade between the kingdoms of Scotland and England. </p>
                <p className="" variants={textAnimate}>‘Drovers’ were the people who moved animals to market, pushing huge numbers of cattle along tracks like the one I’m walking on. Usually this took place over summer and autumn. The days would have been warm, and as my skin sticks and flies dance around me, I wonder what their journey would have been like. Hundreds of miles underfoot, in shoes far more modest than my hiking boots, sometimes from Skye or the far north Highlands to the </p>
              </div>
            </div>
            <img className="img-fluid mb-4"
              src={require("../../Images/article10-right-img2.jpg")}
            />
          </div>

          <div className="" ref={secondContainer}>
            <img className="img-fluid mb-4"
              src={require("../../Images/article10-right-img1.jpg")}
            />
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>cities. Challenges aplenty: robbers, rivers, bad weather, navigation, illness. These hills would have been the last summits before the main market at Falkirk. </p>
                <p className="" variants={textAnimate}>Alongside my surprise at how clear the route still is today, there’s something else. There are still sheep on this path, watching me. One meets my gaze, and its eyes are a mirror through time. </p>
                <p className="" variants={textAnimate}>Over hill and glen to the west lies the Drovers’ Inn. Built over 300 years ago, this beefy stone building promised a welcome relief to those driving cattle down Loch Lomondside. Now, it’s a popular pitstop for another kind of long-distance hiker </p>
                <p className="" variants={textAnimate}>The West Highland Way, Scotland’s most popular walking route since its inception in 1980, passes by the inn on its way north. This 96 mile (154 km) trek begins in a Glasgow suburb before weaving through forest, beside dark lochs, over field and moor, and on to the iconic Glen Coe </p>
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>mountains. Some walkers — like Brooklynbased filmmaker Kraig Adams — choose to summit Ben Nevis, the UK’s tallest peak, as the final flourish to their trip. </p>
                <p className="" variants={textAnimate}>Although this was Kraig’s first time hiking the West Highland Way, he’s hiked all over the world. I was curious — why Scotland and why now? Many higher trails in Europe and North America are still snowed in at the end of spring, Kraig explained, so it seemed like a good opportunity to try a lower-elevation route in Scotland. </p>
                <p className="" variants={textAnimate}>Despite aiming to complete the Way as quickly as possible, Kraig still found time for connection. “I talked to plenty of other people on the trail taking seven or eight days to mosey their way up north. The age diversity of the hikers surprised me — everyone hikes for their own reasons and at their own pace.” </p>
                <p className="" variants={textAnimate}>What is it about solo hiking that Kraig keeps returning to, whether through the </p>
              </div>
            </div>

            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>landscapes of Scotland or Switzerland? “It’s all about exploring nature and other cultures,” Kraig says. “Letting go of normal comforts and allowing yourself to be dirty. Balancing safety and fun. Less is more.” </p>
                <p className="" variants={textAnimate}>That familiar echo of a simpler life, lived at walking speed, seems to sound through the centuries. </p>
                <p className="" variants={textAnimate}>However fast or slow you go, any longdistance journey is both physical and emotional — particularly when you’re crossing an entire country. </p>
                <p className="" variants={textAnimate}>Launched in 2012 by outdoors writer Cameron McNeish, the Scottish National Trail or SNT knits 537 miles (864 km) of Scotland. From Borders countryside to Edinburgh cobbles, flanking the Forth and Clyde canal to the forested Trossachs, cresting the Cairngorm plateau, then navigating the often-pathless northwest Highlands before the Cape Wrath lighthouse finish, this epic route takes around five weeks. </p>
                <p className="" variants={textAnimate}>“I stumbled across the SNT on the internet and something inside me said ‘you have to do this’,” says Yvette Webster, a travel writer and the first solo woman to hike the trail. Before the SNT, Yvette had never wild camped alone or completed a long-distance hike. Yet despite these reservations, Yvette’s biggest challenge was within. </p>
                <p className="" variants={textAnimate}>“When you take yourself out of your environment, away from everyone and everything you know, and have all the time in the world to just think, every little piece of trauma you’ve experienced throughout your life decides to show up,” Yvette explains. “You cannot hide from yourself when you’re alone in nature.” </p>
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>Yet as the miles faded and the landscape changed, Yvette’s confidence grew. “I met so many wonderful people on my walk that restored my faith in society. And the further I walked, the louder my intuitive voice became.” </p>
                <p className="" variants={textAnimate}>The most surprising section of the trail for Yvette, in more ways than one, was the often-overlooked Scottish Borders. “I think the first week on any long-distance trail is the hardest. I had a blister that took over my entire heel! But in the Borders, you’re walking Roman and drovers’ roads, literally in the footsteps of history. If I could rewalk a section again for fun, it would be that one.” </p>
                <p className="" variants={textAnimate}>Although Yvette completed the SNT several years ago, the lessons she learnt on the trail remain. Now settled in West Lothian with her husband, baby boy, and a book on the way about her experience, what’s her advice to beginners? “Practice being outdoors more. And practice walking uphill and downhill in your hiking boots!” </p>
                <p className="" variants={textAnimate}>Routes like the SNT are a reminder that, thanks to Scotland’s outdoor access laws — where the public has a legal right to roam responsibly — it can be easier here than in other countries to dream up distance routes, however informal. And, thanks to technology, that’s becoming even easier. </p>
                <p className="" variants={textAnimate}>Slow Ways is a collaborative project to connect walking and cycling routes across Scotland, England and Wales, dreamed up in 2020 by former geography teacher turned explorer Dan Raven-Ellison. It’s based on that age-old question I asked earlier — why do we walk? — which, as founder Dan says, “people have been asking for roughly two million years”. </p>
              </div>
            </div>

            
            <div className="row mb-4 mb-sm-5">
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>One of the key principles of Slow Ways is that people should be able to walk or wheel between any town or city. Faced with overlapping crises — from the climate to cost of living — “greener, healthier and affordable travel” has never been more important. </p>
                <p className="" variants={textAnimate}>I unlock my phone and on the Slow Ways app, bright lines etch themselves over the landscape, opening up opportunities to explore from my doorstep. Volunteers like Jo Bennie have already mapped thousands of routes across Britain totalling over 130,000km, blending heritage and technology to facilitate better outdoor access and preserve paths for future generations. </p>
                <p className="" variants={textAnimate}>Jo walked a three-day Slow Ways route from Aviemore to Braemar through the Cairngorms National Park. “The experience of moving through the old-growth Caledonian forest alongside the wandering </p>
                <div className="bg-green px-3 py-4 text-white f-lora">
                  <h4 className="mb-3">Sources.</h4>
                  <h6 className="mb-2">Books</h6>
                  <p className="mb-4 fs-xs">The Hidden Ways by Alistair Moffat
                  <br/>The Drove Roads of Scotland by A. R. B. Haldane
                  <br/>The Unremembered Places by Patrick Baker
                  <br/>Walking: One Step at a Time by Erling Kagge</p>

                  <h6 className="mb-2">Websites</h6>
                  <p className="fs-xs">walkhighlands.co.uk
                  <br/>scotlandsgreattrails.com
                  <br/>scotways.com</p>

                </div>
                
              </div>
              <div className="col-sm-6">
                <p className="" variants={textAnimate}>Founder Dan echoes this. “Slow Ways is not just a network for walking, it’s communitymade infrastructure for delight, memory, hope, connections, wellness, climate, creativity and so much more.” </p>
                <p className="" variants={textAnimate}>What’s next for Slow Ways? One of the many heartening things about this project is that no matter your ability or where you live, you can get involved. “Anyone who likes walking, running, or wheeling’ can help to verify the routes, Dan explains. “Just choose a route from the Slow Ways website or app, follow it, and leave a review. It’s not just about going further, it’s about going deeper.” </p>
                <p className="" variants={textAnimate}>Our ancestors had many different reasons for walking. So do we. One of the reasons I walk is that it gives me the opportunity to notice and slow down. Each walk I take is a stitch in my relationship with Scotland, deepening with time and something I wear proudly as the years pass. </p>
                <p className="" variants={textAnimate}>In his book ‘Walking: One Step at a Time’, Norwegian explorer and publisher Erling Kagge says that “walking [is] a combination of movement, humility, balance, curiosity, smell, sound, light and — if you walk far enough — longing. A feeling which reaches for something, without finding it.” </p>
                <p className="" variants={textAnimate}>Muscle mingling with moss, hair with lichen, breath with fog. Yes, walking is an act, but it’s also a feeling. A feeling that mirrors our journey through life, searching for ourselves. </p>
              </div>
            </div>
            
          </div>
        </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article10;
